import { EntidadeBase } from 'hay-core-react';
class GrupoPermissaoModel extends EntidadeBase {
    constructor() {
        super('grupopermissao');
    }
}

const instance = new GrupoPermissaoModel();
export default instance;
